import React, { useEffect } from 'react';

import { Container, MenuItem, ContainerTop, MenuItemTop } from './styles';

import { useProductsCompany } from '../../../../hooks/productsCompany';

const { REACT_APP_SHOW_SCROLLBAR_POS } = process.env;

const MenuCategories: React.FC = () => {
  const { loadProducts, categories, categorySelected, setCategorySelected } =
    useProductsCompany();

  useEffect(() => {
    loadProducts();
  }, [loadProducts]);

  return (
    <>
      <ContainerTop showScrollbar={!!REACT_APP_SHOW_SCROLLBAR_POS}>
        {categories.map(item => (
          <MenuItemTop
            key={`mobile-${item.uid}`}
            active={categorySelected.uid === item.uid}
            onClick={() => setCategorySelected(item)}
          >
            {item.image && <img src={item.image} alt="Ilutracao" />}
            <p>{item.name}</p>
          </MenuItemTop>
        ))}
      </ContainerTop>
      <Container showScrollbar={!!REACT_APP_SHOW_SCROLLBAR_POS}>
        {categories.map(item => (
          <MenuItem
            key={`desktop-${item.uid}`}
            active={categorySelected.uid === item.uid}
            onClick={() => setCategorySelected(item)}
          >
            {item.image && <img src={item.image} alt="Ilutracao" />}
            <p>{item.name}</p>
          </MenuItem>
        ))}
      </Container>
    </>
  );
};

export default MenuCategories;
